import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./Checkbox.scss";

const Checkbox = ({
	id,
	checked,
	onChange,
	label,
	className
}) => (
	<label htmlFor={id} className={classnames("checkbox", className)}>
		<input
			id={id}
			type="checkbox"
			checked={checked}
			onChange={onChange}
		/>
		<span className="checkbox-custom" />
		{label && <span className="checkbox-label">{label}</span>}
	</label>
);

Checkbox.propTypes = {
	id: PropTypes.string,
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
	label: PropTypes.string,
	className: PropTypes.string
};

Checkbox.defaultProps = {
	id: null,
	label: "",
	className: ""
};

export default Checkbox;
